<template>
        <v-menu v-if="pcOnly" v-model="showNotifications" :close-on-content-click="false" :offset-y="true" left transition="slide-y-transition"> <!-- fade-up -->
            <template v-slot:activator="{}">
                <v-btn icon :color="!!newNotifications ? 'strong-text' : 'grey darken-2'" class="icon-wrapper me-2" @click.prevent="openNotifications">
                    <v-badge class="notification-badge" :value="!!newNotifications" color="primary" :content="newNotifications" overlap right>
                        <v-icon size="25">{{newNotifications ? 'mdi-bell' : 'mdi-bell-outline' }}</v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <v-list width="400" max-height="600">
                <div class="d-flex justify-space-between pb-2 px-4 align-center">
                    <div class="medium-text">اﻹشعارات</div>
                    <div class="details-text" :class="{'primary--text': unseenCount, 'grey--text': !unseenCount}">{{unseenText}}</div>
                </div>

                <v-divider />
                
                <vue-custom-scrollbar class="scroll-area" :wheelPropagation="false" :scrollingThreshold="500">
                    <div class="notifications-wrapper">
                        <div v-for="notification in notifications" :key="notification.id" class="notification-wrapper">
                            <notification :notification="notification" />
                        </div>
                    </div>

                    <div class="d-flex justify-center align-center mt-2">
                        <v-btn text small :disabled="!existsMore" color="primary darken-2" @click="showMore = true">عرض المزيد من اﻹشعارات</v-btn>
                    </div>
                </vue-custom-scrollbar>
                
            </v-list>
        </v-menu>
        <dir v-else>
            <v-btn icon :color="!!newNotifications ? 'strong-text' : 'grey darken-2'" class="icon-wrapper me-2" @click.prevent="openNotifications">
                <v-badge class="notification-badge" :value="!!newNotifications" color="primary" :content="newNotifications" overlap right>
                    <v-icon size="25">{{newNotifications ? 'mdi-bell' : 'mdi-bell-outline' }}</v-icon>
                </v-badge>
            </v-btn>

            <v-dialog v-model="showNotifications" fluid scrollable fullscreen overlay-color="#000" transition="slide-y-reverse-transition">
                <v-card>
                    <div class="d-flex justify-space-between py-2 px-4 align-center" :class="{'mt-7': statusBarOverlay}">
                        <div class="d-flex align-center">
                            <div class="medium-text">اﻹشعارات</div>
                            <div class="details-text ms-3" :class="{'primary--text': unseenCount, 'grey--text': !unseenCount}">({{unseenText}})</div>
                        </div>
                        <div>
                            <v-btn icon color="muted" @click="showNotifications = false;">
                                <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                        </div>
                    </div>

                    <v-divider />
                    
                    <v-card-text class="pb-0 px-0">

                        <v-list>
                            <div class="notifications-wrapper">
                                <div v-for="notification in notifications" :key="notification.id" class="notification-wrapper">
                                    <notification :notification="notification" />
                                </div>
                            </div>

                            <div class="d-flex justify-center align-center mt-2">
                                <v-btn text small :disabled="!existsMore" color="primary darken-2" @click="showMore = true">عرض المزيد من اﻹشعارات</v-btn>
                            </div>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-dialog>

        </dir>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import Notification from '../../default/notification'
import vueCustomScrollbar from 'vue-custom-scrollbar'

// import GlobalMethods from '@/helpers/global-methods'

export default {
    data(){
        return {
            showNotifications: false,
            showMore: false,
            limit: 10,
        }
    },
    components: {
        Notification,
        vueCustomScrollbar
    },
    computed: {
        ...GlobalComputed,
        existsMore(){
            return this.allNotifications.length > this.notifications.length;
        },
        notifications(){
            let notifications = this.allNotifications;
            if (!notifications){
                return [];
            }
            return this.showMore ? notifications : notifications.slice(0, this.limit);
        },
        allNotifications(){
            return this.user.notifications;
        },
        unseenCount(){
            let unseen = this.allNotifications.filter(n=>{
                return !n.read;
            });
            return unseen.length;
        },
        unseenText(){
            let count = this.unseenCount;
            if (count){
                if (count){
                    return 'إشعار واحد جديد';
                }else if (count){
                    return 'إشعاران جديدان'
                }else if (count <= 10){
                    return `${count} إشعارات جديدة`
                }else{
                    return `${count} إشعار جديد`
                }
            }
            return 'لا يوجد جديد';
        },
        newNotifications(){
            let unread = this.user.notifications_count;
            // let unread = 122;
            return unread > 99 ? '+99' : unread;
        },
        statusBarOverlay(){
            return this.platform === 'ios';
        },
    },
    methods: {
        markAllAsRead(){
            if (this.user.notifications_count > 0){
                this.$store.dispatch('markAllAsRead');
            }
        },
        openNotifications(){
            if (this.notifications.length){
                this.showNotifications= !this.showNotifications;
                window.setTimeout(()=>{
                    this.markAllAsRead();
                }, 2000);
            }
        }
    }
}
</script>

<style lang="scss">

    .scroll-area {
        position: relative;
        margin: auto;
        max-height: 500px!important;
    }

    .notification-badge.v-badge--bordered .v-badge__badge{
        font-weight: bold;
        &::after{
            // right: 2px!important;
        }
    }
</style>